import React from "react";
import PayTypesSection from "./PayTypesSection";

// The set of bonus types a company admin can build default bonuses from. Each
// entry carries a human-readable label, a plain-language description of how the
// bonus pays out, and the default legal document text used when the bonus type
// is referenced in a rep's agreement.
const BONUS_TYPES = [
  {
    value: "ITEM",
    label: "Item",
    description:
      "A non-cash bonus awarded as a physical item or product when the qualifying criteria are met.",
    documentText:
      "Upon meeting the qualifying criteria, the Representative shall be awarded the item specified for this bonus.",
  },
  {
    value: "MONEY",
    label: "Money",
    description:
      "A cash bonus paid out as a one-time dollar amount when the qualifying criteria are met.",
    documentText:
      "Upon meeting the qualifying criteria, the Representative shall receive a one-time cash bonus in the amount specified.",
  },
  {
    value: "RECURRING",
    label: "Recurring",
    description:
      "A bonus paid out on a recurring basis for the duration of the applicable period while the qualifying criteria continue to be met.",
    documentText:
      "Upon meeting the qualifying criteria, the Representative shall receive a recurring bonus in the amount specified, payable on a recurring basis for the duration of the applicable period.",
  },
];

function BonusTypesList({ companyTypes, onTypesChange }) {
  return (
    <PayTypesSection
      intro="The following bonus types are available when configuring default bonuses."
      types={BONUS_TYPES}
      companyTypes={companyTypes}
      endpoint="bonus"
      onTypesChange={onTypesChange}
    />
  );
}

export default BonusTypesList;
